import {ENV_DEV} from '~/config/constants';

require('~/utils/shims');
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import {ErrorHandlerComponent} from '@components/layout/error-handler/error-handler.component';
import {Config} from '~/config';

import { AppContainer } from 'react-hot-loader'
import {ErrorHandlerTemplate} from '@components/layout/error-handler/error-handler.template';

if (process.env.NODE_ENV === ENV_DEV && module.hot) {
    module.hot.accept();
}

if (Config.params.BUGSNAG) {
    Bugsnag.start({
        apiKey: Config.params.BUGSNAG,
        plugins: [new BugsnagPluginReact()],
        appVersion: Config.app.version,
        releaseStage: Config.app.env,
        enabledReleaseStages: [ 'stage', 'production' ],

        // autoDetectErrors: true,
        // enabledBreadcrumbTypes: ['error', 'log', 'navigation', 'request', 'user'],
        // onError: function (event) {
        //     console.log(event)
        //     event.errors[0].stacktrace = event.errors[0].stacktrace.map(function (frame) {
        //         frame.file = frame.file.replace(/chrome-extension:/g, 'chrome_extension:')
        //         frame.file = frame.file.replace(/moz-extension:/g, 'moz_extension:')
        //         return frame
        //     })
        // }
    })

    var ErrorBoundary = Bugsnag.getPlugin('react')
        .createErrorBoundary(React)

    ReactDOM.render(
        <ErrorBoundary FallbackComponent={ErrorHandlerTemplate}>
            <AppContainer>
                <App />
            </AppContainer>
        </ErrorBoundary>,
        document.getElementById('root')
    );
} else {
    ReactDOM.render(
        <ErrorHandlerComponent>
            <AppContainer>
                <App />
            </AppContainer>
        </ErrorHandlerComponent>,
        document.getElementById('root')
    );
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
